/* global globalThis */

import { createSlice } from "@reduxjs/toolkit";

// Check if user came from outside the current domain
const isNewVisit =
  document.referrer === "" ||
  !document.referrer.includes(globalThis.location.hostname);

let savedLang = "मराठी";

if (!isNewVisit) {
  savedLang = globalThis.localStorage.getItem("selectedLang") || "मराठी";
}

const languageSlice = createSlice({
  name: "language",
  initialState: {
    selectedLang: savedLang,
  },
  reducers: {
    setLanguage: (state, action) => {
      state.selectedLang = action.payload;
      localStorage.setItem("selectedLang", action.payload);
    },
  },
});

export const { setLanguage } = languageSlice.actions;
export default languageSlice.reducer;
